import PropTypes from "prop-types";
import styles from "./BetButton.module.scss";
import useBetSlip from "../../hooks/useBetSlip";

const BetButton = ({ selectionData }) => {
  const { selection } = selectionData;
  const [isActive, updateBetslip, oddsFormat] = useBetSlip(selection);

  const handleSelection = (e) => {
    e.stopPropagation();
    updateBetslip(selectionData);
  };
  return (
    <button
      className={`${styles.betButton} ${
        isActive ? styles["betButton--active"] : ""
      }`}
      type="button"
      onClick={(e) => handleSelection(e)}
    >
      {oddsFormat === "Decimal"
        ? selection.oddsDecimal.toFixed(2)
        : selection.odds}
    </button>
  );
};

BetButton.propTypes = {
  selectionData: PropTypes.shape({
    selection: PropTypes.shape({
      commonID: PropTypes.number,
      id: PropTypes.string,
      marketId: PropTypes.string,
      name: PropTypes.string,
      odds: PropTypes.string,
      oddsDecimal: PropTypes.number,
      type: PropTypes.string,
    }),
  }),
};

export default BetButton;
